import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const MediaLayoutRight = ({
  height = 24,
  width = 24,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => {
  return (
    <SvgIcon data-temporary-fix height={height} width={width} {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.7143 1.55078H2.28571C1.41784 1.55078 0.714286 2.28951 0.714286 3.20078V12.8008C0.714286 13.712 1.41784 14.4508 2.28572 14.4508H29.7143C30.5822 14.4508 31.2857 13.7121 31.2857 12.8008V3.20078C31.2857 2.28951 30.5822 1.55078 29.7143 1.55078ZM2.28571 0.800781C1.02335 0.800781 0 1.8753 0 3.20078V12.8008C0 14.1263 1.02335 15.2008 2.28572 15.2008H29.7143C30.9767 15.2008 32 14.1263 32 12.8008V3.20078C32 1.8753 30.9767 0.800781 29.7143 0.800781H2.28571Z"
        fill={getColor(color, isColorInherited)}
      />
      <path
        d="M28.5714 3.50078C29.2026 3.50078 29.7143 4.03804 29.7143 4.70078V7.70078C29.7143 8.36352 29.2026 8.90078 28.5714 8.90078H25.7143C25.0831 8.90078 24.5714 8.36352 24.5714 7.70078V4.70078C24.5714 4.03804 25.0831 3.50078 25.7143 3.50078H28.5714Z"
        fill={getColor(color, isColorInherited)}
      />
      <path
        d="M22 3.50078C22.4734 3.50078 22.8571 3.90372 22.8571 4.40078C22.8571 4.89784 22.4734 5.30078 22 5.30078H3.14286C2.66947 5.30078 2.28571 4.89784 2.28571 4.40078C2.28571 3.90372 2.66947 3.50078 3.14286 3.50078H22Z"
        fill={getColor(color, isColorInherited)}
      />
      <path
        d="M22 7.10078C22.4734 7.10078 22.8571 7.50372 22.8571 8.00078C22.8571 8.49784 22.4734 8.90078 22 8.90078H3.14286C2.66947 8.90078 2.28571 8.49784 2.28571 8.00078C2.28571 7.50372 2.66947 7.10078 3.14286 7.10078H22Z"
        fill={getColor(color, isColorInherited)}
      />
      <path
        d="M7.42857 11.6008C7.42857 11.1037 7.04482 10.7008 6.57143 10.7008H3.14286C2.66947 10.7008 2.28571 11.1037 2.28571 11.6008C2.28571 12.0978 2.66947 12.5008 3.14286 12.5008H6.57143C7.04482 12.5008 7.42857 12.0978 7.42857 11.6008Z"
        fill={getColor(color, isColorInherited)}
      />
    </SvgIcon>
  );
};
